import React, { Component } from 'react';
import { debounce } from 'lodash';
import { add as addEvent } from 'bianco.events';
import { LayoutProvider } from 'react-page-layout';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import t from 'translations';

import { getViewportData } from 'util/dom/mq';
import scrollTop from 'util/dom/scroll-top';
import { RESIZE_DEBOUNCE } from 'constants/debounce-delays';
// Components
import SidePanel from 'components/side-panel';
import MainHeader from 'components/main-header';
import ContentOverlay from 'components/content-overlay';
import Modal from 'components/modal';
import DeliveryNotification from 'components/delivery-notification';
import Autologin from 'components/autologin';
// import Feedbackify from 'components/feedbackify';
import LiveChat from 'components/livechat';
import AccessibleAlert from 'components/accessibile-alert';
import SkipLinks from 'components/skiplinks';
import Snackbar from 'components/snackbar';
import webview from 'layouts/webview';
// Pages layouts
import layouts from 'layouts';

let currentScrollTop = scrollTop();

const nativeLayouts = Object.keys(layouts).reduce((acc, key) => {
    acc[key] = webview;
    return acc;
}, {});

class Root extends Component {
    static propTypes = {
        modal: PropTypes.object.isRequired,
        isScrollLocked: PropTypes.bool.isRequired,
        scrollbarWidth: PropTypes.number.isRequired,
        setViewport: PropTypes.func.isRequired,
        isNative: PropTypes.bool.isRequired,
        children: PropTypes.object.isRequired,
        isDesktop: PropTypes.bool,
        location: PropTypes.object.isRequired,
        isCmsEnabled: PropTypes.bool.isRequired,
        setNetworkState: PropTypes.func.isRequired,
        hasViewportOverlay: PropTypes.bool.isRequired,
        isMobile: PropTypes.bool,
        isSearchActive: PropTypes.bool.isRequired,
        isTouch: PropTypes.bool.isRequired,
        panelFacet: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            isPrelaunch: (window.location.href.indexOf('prelaunch-counter') > -1),
        };
        this.updateViewport();
    }

    componentDidMount() {
        addEvent(window, 'resize orientationchange', debounce(this.updateViewport, RESIZE_DEBOUNCE), { passive: true });
        addEvent(window, 'scroll', this.onScroll, { passive: true });
        addEvent(window, 'online offline', this.onNetworkStateChanged, { passive: true });
    }

    componentDidUpdate(prevProps) {
        const { isTouch, isSearchActive, isScrollLocked, modal, scrollbarWidth } = this.props;

        /**
         * Dirty hacks here sorry...! The MLogin service forces us doing nasty stuff with iframes and modals pfff..
         * There are no better solutions at moment
         * @TODO: give us an interface to manage the users profile info!!!
         */
        if (prevProps.isScrollLocked !== isScrollLocked) {
            const isIframeModal = modal.layout === 'iframe';

            if (isIframeModal) {
                // no need to remove this class because on close we will trigger a page reload
                document.documentElement.classList.add('scroll-root__is-locked-iframe');
            } else {
                let classToToggle = 'scroll-root__is-locked';

                if (isTouch && isSearchActive && isScrollLocked) {
                    classToToggle = 'scroll-root__is-locked--mobile-touch-search';
                }

                document.documentElement.classList[isScrollLocked ? 'add' : 'remove'](classToToggle);
                if (isScrollLocked) {
                    document.body.style.top = `${ -currentScrollTop }px`;
                    document.body.style.paddingRight = `${ scrollbarWidth }px`;
                } else {
                    document.body.style.top = null;
                    document.body.style.paddingRight = null;
                    window.scrollTo(0, currentScrollTop);
                }
            }
        }
    }

    onNetworkStateChanged = () => {
        this.props.setNetworkState({ isOnline: navigator.onLine });
    };

    onScroll = () => {
        if (this.props.isScrollLocked) {
            return;
        }

        const newScrollTop = scrollTop();
        currentScrollTop = newScrollTop;
    };

    updateViewport = () => {
        this.props.setViewport({
            width: window.innerWidth,
            height: window.innerHeight,
            mq: getViewportData(),
        });
    };

    /*
    // see MCART-2086
    renderFeedbackify = () => {
        if (this.state.isPrelaunch || this.props.isNative) {
            return '';
        }
        return <Feedbackify/>;
    };
    */

    renderLiveChat = () => {
        if (this.state.isPrelaunch || this.props.isNative) {
            return '';
        }

        return <LiveChat/>;
    };

    render() {
        const { hasViewportOverlay, modal, children, panelFacet, isNative } = this.props;

        return (
            <div className="skel--main">
                {!isNative && <div tabIndex="-1" id="topconent"></div>}
                {!isNative &&
                <AccessibleAlert
                    messageMobile={t('accessibility.alert.site_is_mobile')}
                    messageDesktop={t('accessibility.alert.site_is_desktop')}
                />}
                {!isNative && <SkipLinks/>}
                {!isNative && <Autologin/>}
                {!isNative && <MainHeader/>}
                <div aria-hidden={hasViewportOverlay} id="main" className="skel--content" aria-live="polite">
                    <LayoutProvider layouts={isNative ? nativeLayouts : layouts}>{children}</LayoutProvider>
                </div>
                <ContentOverlay isVisible={hasViewportOverlay} facet={modal.isVisible || panelFacet === 'cart' ? 'modal' : 'base'}/>
                {modal.isVisible && <Modal {...modal} />}
                {!isNative && <SidePanel/>}
                {!isNative && <DeliveryNotification/>}
                {/* this.renderFeedbackify() */}
                { this.renderLiveChat() }
                {!isNative && <Snackbar/>}
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        isScrollLocked: 'scroll.isLocked',
        scrollbarWidth: 'scroll.scrollbarWidth',
        hasViewportOverlay: 'viewport.hasOverlay',
        isDesktop: 'viewport.isDesktop',
        modal: 'modal',
        isNative: 'viewport.isNative',
        panelFacet: 'panel.facet',
        isCmsEnabled: 'cms.isEnabled',
        isSearchActive: 'search.isActive',
        isMobile: 'viewport.isMobile',
        isTouch: 'viewport.touchevents',
    }),
    reduxUtils.mapDispatchToProps({
        setViewport: 'viewport.setViewport',
        setNetworkState: 'navigator.setNetworkState',
    }),
)(Root);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/main/root.js